export * from './app-sidebar-minimizer.component';



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/components/app-sidebar-minimizer/index.ts